import React, { Component, Fragment } from "react";
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Head from '../../components/Head/Head';
import Sidebar from '../../components/Sidebar/Sidebar';
import BlackList from '../../components/BlackList/BlackList';
import ImportOrders from '../../components/ImportOrders/ImportOrders';
import PriceList from '../../components/PriceList/PriceList';
import OrdersItems from '../../components/OrdersPage/OrdersItems/OrdersItems';
import RefundRequestsItems from '../../components/RefundRequests/RefundRequestsItems/RefundRequestsItems';
import OrdersPage from '../../components/OrdersPage/OrdersPage';
import Transactions from '../../components/Transactions/Transactions';
import TransactionsItem from "../../components/Transactions/TransactionsItem/TransactionsItem";
import RefundRequestsSupplier from '../../components/RefundRequestsSupplier/RefundRequestsSupplier';
import RefundRequestsBuyer from '../../components/RefundRequestsBuyer/RefundRequestsBuyer';
import RefundRequestsItemsBuyer from '../../components/RefundRequestsBuyer/RefundRequestsItemsBuyer';
import RefundRequestsItemsSupplier from '../../components/RefundRequestsSupplier/RefundRequestsItemsSupplier';
import GoodsReception from '../../components/GoodsReception/GoodsReception';
import DisposalBalances from '../../components/DisposalBalances/DisposalBalances';
import ReturnDispatches from '../../components/ReturnDispatches/ReturnDispatches';
import ReturnDispatchSupplier from '../../components/ReturnDispatches/ReturnDispatchSupplier/ReturnDispatchSupplier';
import ReturnDispatchesItems from '../../components/ReturnDispatches/ReturnDispatchesItems/ReturnDispatchesItems';
import NewReturnDispatch from '../../components/ReturnDispatches/NewReturnDispatch/NewReturnDispatch';
import NewIssue from '../../components/DisposalBalances/NewIssue/NewIssue';
import NewIssueV2 from '../../components/DisposalBalances/NewIssue/NewIssueV2';
import ImportOrdersInner from '../../components/ImportOrders/ImportOrdersInner/ImportOrdersInner';
import NotFound from '../../components/NotFound/NotFound';
import ProtectedRoute from '../../components/HelperComponents/ProtectedRoute/ProtectedRoute';

import { getUser } from "../../actions/userActions";
import { getDefaultPath, SECTIONS } from "../../helpers/roles";

class Container extends Component {
     state = {
        open: false
    };

    componentDidMount() {
        const { getUser } = this.props;
        getUser();
    }

    toggleDrawer = () => {
        this.setState(({open}) => ({
            open: !open
        }));
    };

    render() {
        const { match, history, userRole, userLoaded } = this.props;
        const { open } = this.state;
        
        if(!localStorage.token) return <Redirect to="/auth" />;
        
        if (!userLoaded) {
            return null;
        }

        const defaultPath = getDefaultPath(userRole);

        return (
            <Fragment>
                <Head history={history} open={open} onClick={this.toggleDrawer} />
                <Sidebar open={open} onClick={this.toggleDrawer} />
                <Switch>
                    <Route path={match.url} exact render={() => <Redirect to={defaultPath} />} />
                    
                    <ProtectedRoute 
                        path={`${match.url}/price-list`} 
                        exact 
                        component={PriceList} 
                        section={SECTIONS.PRICE_LIST}
                    />
                    <ProtectedRoute 
                        path={`${match.url}/import-orders`} 
                        exact 
                        component={ImportOrders}
                        section={SECTIONS.IMPORT_ORDERS}
                    />
                    <ProtectedRoute 
                        path={`${match.url}/import-orders-inner`} 
                        exact 
                        component={ImportOrdersInner}
                        section={SECTIONS.IMPORT_ORDERS}
                    />
                    <ProtectedRoute 
                        path={`${match.url}/black-list`} 
                        exact 
                        component={BlackList}
                        section={SECTIONS.BLACK_LIST}
                    />
                    <ProtectedRoute 
                        path={`${match.url}/orders-page`} 
                        exact 
                        component={OrdersPage}
                        section={SECTIONS.ORDERS_PAGE}
                    />
                    <ProtectedRoute 
                        path={`${match.url}/orders-items/:idOrder`} 
                        exact 
                        component={OrdersItems}
                        section={SECTIONS.ORDERS_PAGE}
                    />
                    <ProtectedRoute 
                        path={`${match.url}/transactions`} 
                        exact 
                        component={Transactions}
                        section={SECTIONS.TRANSACTIONS}
                    />
                    <ProtectedRoute 
                        path={`${match.url}/transactions/:id`} 
                        exact 
                        component={TransactionsItem}
                        section={SECTIONS.TRANSACTIONS}
                    />
                    <ProtectedRoute
                        path={`${match.url}/refund-requests-supplier`}
                        exact
                        component={RefundRequestsSupplier}
                        section={SECTIONS.REFUND_REQUESTS_SUPPLIER}
                    />
                    <ProtectedRoute
                        path={`${match.url}/refund-requests-buyer`}
                        exact
                        component={RefundRequestsBuyer}
                        section={SECTIONS.REFUND_REQUESTS_BUYER}
                    />
                    <ProtectedRoute
                        path={`${match.url}/refund-request-buyer/:id`}
                        exact
                        component={RefundRequestsItemsBuyer}
                        section={SECTIONS.REFUND_REQUESTS_BUYER}
                    />
                    <ProtectedRoute
                        path={`${match.url}/refund-request-supplier/:id`}
                        exact
                        component={RefundRequestsItemsSupplier}
                        section={SECTIONS.REFUND_REQUESTS_SUPPLIER}
                    />
                    <ProtectedRoute
                        path={`${match.url}/refund-request/:id`}
                        exact
                        component={RefundRequestsItems}
                        section={SECTIONS.REFUND_REQUESTS_SUPPLIER}
                    />
                    <ProtectedRoute 
                        path={`${match.url}/good-reception`} 
                        exact 
                        component={GoodsReception}
                        section={SECTIONS.GOOD_RECEPTION}
                    />
                    <ProtectedRoute 
                        path={`${match.url}/disposal-balances`} 
                        exact 
                        component={DisposalBalances}
                        section={SECTIONS.DISPOSAL_BALANCES}
                    />
                    <ProtectedRoute
                        path={`${match.url}/return-dispatches`}
                        exact
                        component={ReturnDispatches}
                        section={SECTIONS.RETURN_DISPATCHES}
                    />
                    <ProtectedRoute
                        path={`${match.url}/return-dispatches/:supplierId`}
                        exact
                        component={ReturnDispatchSupplier}
                        section={SECTIONS.RETURN_DISPATCHES}
                    />
                    <ProtectedRoute
                        path={`${match.url}/return-dispatch/:id`}
                        exact
                        component={ReturnDispatchesItems}
                        section={SECTIONS.RETURN_DISPATCHES}
                    />
                    <ProtectedRoute
                        path={`${match.url}/new-return-dispatch`}
                        exact
                        component={NewReturnDispatch}
                        section={SECTIONS.RETURN_DISPATCHES}
                    />
                    <ProtectedRoute 
                        path={`${match.url}/new-issue/old`} 
                        exact 
                        component={NewIssue}
                        section={SECTIONS.DISPOSAL_BALANCES}
                    />
                    <ProtectedRoute 
                        path={`${match.url}/new-issue`} 
                        exact 
                        component={NewIssueV2}
                        section={SECTIONS.DISPOSAL_BALANCES}
                    />
                    
                    <Route component={NotFound} />
                </Switch>
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        userRole: state.user.current_user.role,
        userLoaded: state.user.current_user.loaded,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getUser,
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Container);
